"use client";

import { makeApiRequest } from "@web/lib/data";
import { useCallback, useState } from "react";

export default function Contact() {
  const [from, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [message, setMessage] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const send = useCallback(async () => {
    setBusy(true);
    try {
      await makeApiRequest("POST", "contact/send", undefined, {
        from,
        lastName,
        firstName,
        message,
      });
    } finally {
      setBusy(false);
    }
    setSent(true);
  }, [from, firstName, lastName, message]);
  return sent ? (
    <div className="text-lg">
      <p>Your message was sent succesfully!</p>
      <p>We will contact you as soon as possible.</p>
    </div>
  ) : (
    <form
      onSubmit={(e) => {
        send();
        e.preventDefault();
      }}
    >
      <div className="text-base mb-[11px]">
        <div className="text-white pb-1 text-sm font-bold leading-tight">
          E-mail
        </div>
        <input
          onChange={(e) => setEmail(e.target.value)}
          value={from}
          type="email"
          className="w-full h-10 text-white px-4 placeholder-white font-semibold  bg-[#2A2A2A] border border-gray-700 rounded-md"
        />
      </div>
      <div className="text-base mb-[11px]">
        <div className="text-white pb-1 text-sm font-bold leading-tight">
          First name
        </div>
        <input
          onChange={(e) => setFirstName(e.target.value)}
          value={firstName}
          type="text"
          className="w-full h-10 text-white px-4 placeholder-white font-semibold  bg-[#2A2A2A] border border-gray-700 rounded-md"
        />
      </div>
      <div className="text-base mb-[11px]">
        <div className="text-white pb-1 text-sm font-bold leading-tight">
          Last name
        </div>
        <input
          onChange={(e) => setLastName(e.target.value)}
          value={lastName}
          type="text"
          className="w-full h-10 text-white px-4 placeholder-white font-semibold  bg-[#2A2A2A] border border-gray-700 rounded-md"
        />
      </div>

      <div className="text-base mb-[11px]">
        <div className="text-white pb-1 text-sm font-bold leading-tight">
          Message
        </div>
        <textarea
          onChange={(e) => setMessage(e.target.value)}
          value={message}
          className="w-full h-[175px] text-white px-4 placeholder-white font-semibold  bg-[#2A2A2A] border border-gray-700 rounded-md"
        />
      </div>

      <input
        type="submit"
        value="Send"
        disabled={busy}
        className="disabled:opacity-90 cursor-pointer hover:opacity-90 flex w-full items-center justify-center text-black text-sm font-bold h-10 bg-[#c5ff11] rounded-md linkhover"
      />
    </form>
  );
}
